import { useCustomTranslation } from "@/hooks/useTranslation";
import React, { useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";

function AttachmentsToaster({ isExistingAttachments }) {
  const { content } = useCustomTranslation();
  const getContent = (group, key) => {
    return content(`controls.${group}.${key}`);
  };

  useEffect(() => {
    if (isExistingAttachments) {
      toast.custom(t => (
        <div
          className={`${
            t.visible ? "animate-enter" : "animate-leave"
          }  mb-9 flex justify-center rounded bg-white px-[16px] py-[8px]`}
        >
          <div>{getContent("tooltips", "exiting_attachment")}</div>
        </div>
      ));
    }
  }, [isExistingAttachments]);

  return <Toaster position="bottom-center" reverseOrder={false} />;
}

export default AttachmentsToaster;
